export default __webpack_public_path__ + "static/media/review-sample-photo-3.8cef41a0.jpg";